import { ComponentProps } from 'react';

const BordGpsIcon = (props: ComponentProps<'svg'>) => {
  const { stroke, fill } = props;
  return (
    <svg width="18" height="18" fill="transparent" viewBox="0 0 16 16">
    <path
      d="M13.1757 7.4987C13.1757 10.6283 10.6387 13.1654 7.50907 13.1654C4.37946 13.1654 1.84241 10.6283 1.84241 7.4987C1.84241 4.36908 4.37946 1.83203 7.50907 1.83203C10.6387 1.83203 13.1757 4.36908 13.1757 7.4987Z"
      stroke={stroke || '#141b34'}
    />
    <path d="M14.5 7.49609H13.1666" stroke={stroke || '#141b34'} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1.83333 7.49609H0.5" stroke={stroke || '#141b34'} strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M7.5 0.498698L7.5 1.83203"
      stroke={stroke || '#141b34'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 13.1628V14.4961"
      stroke={stroke || '#141b34'}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill={fill || '#54a1fc'}
    />
    <path
      d="M9.49997 7.49609C9.49997 8.60066 8.60454 9.49609 7.49997 9.49609C6.3954 9.49609 5.49997 8.60066 5.49997 7.49609C5.49997 6.39152 6.3954 5.49609 7.49997 5.49609C8.60454 5.49609 9.49997 6.39152 9.49997 7.49609Z"
      stroke={stroke || '#141b34'}
      fill={fill || 'none'}
    />
  </svg>
  );
};

export default BordGpsIcon;
